import NavBar from "./NavBar.tsx";
import Footer from "./Footer.tsx";
import React from "react";
import { Box } from "@mui/material";

export default function BasePage({
  className,
  children,
}: {
  className: string;
  children: React.ReactNode;
}) {
  return (
    <div className="App">
      <NavBar />
      <Box className={className} sx={{ bgcolor: "grey.50" }}>
        <div className="page-contents">{children}</div>
        <Footer />
      </Box>
    </div>
  );
}
